import { DECIMAL_DIGITS, INTEGER_DIGITS } from 'src/modules/common/constants.ts';

export const formatNumericString = (string: string) => {
    const trimmedString = string.trim();

    if (!trimmedString) {
        return '';
    }

    if (Number.isNaN(Number(trimmedString))) {
        return null;
    }

    const [integerPart, fractionPart = ''] = trimmedString.split('.');

    if (integerPart.length > INTEGER_DIGITS) {
        return null;
    }

    if (fractionPart.length > DECIMAL_DIGITS) {
        return null;
    }

    return parseFloat(trimmedString).toFixed(fractionPart.length);
};
